import { destinationFor, droppableId } from "@/dnd/ids";
import { cnTransferDropTargetSurface } from "@/dnd/transferDropTargetStyles";
import { useDroppable } from "@dnd-kit/core";
import React from "react";

/**
 * Drop target for attaching files to a workspace chat session. Wraps the
 * full chat page surface — not just the composer — so rail / explorer
 * drags can land anywhere on the conversation view.
 */
export function ChatComposerDropTarget({
  flowSessionId,
  children,
  className,
}: {
  flowSessionId: string;
  children: React.ReactNode;
  className?: string;
}) {
  const { setNodeRef, isOver } = useDroppable({
    id: droppableId.chatComposer(flowSessionId),
    data: {
      surface: "chat-composer" as const,
      destination: destinationFor("chat-composer", { flowSessionId }),
    },
  });

  return (
    <div
      ref={setNodeRef}
      className={cnTransferDropTargetSurface({ isOver, className })}
    >
      {children}
    </div>
  );
}
